module.exports = __webpack_public_path__ + "static/media/polis.6af547e4.svg";